import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 text-center">
      <h1 className="text-4xl font-semibold mb-2">404</h1>
      <p className="text-sm text-[var(--color-text-muted)] mb-6">Page not found</p>
      <Link to="/" className="text-[var(--color-accent)] hover:underline text-sm">
        Go home
      </Link>
    </main>
  );
}
